import { createSelector } from '@reduxjs/toolkit';

import type { ChatMetadata, Conversation } from '@/src/shared/types';

import type { chatSlice, ChatState } from './reducer';
import { NEW_CONVERSATION_ID } from './reducer';

const selectChatState = (state: { [chatSlice.name]: ChatState }) => state.chat;

export const selectCurrentConversation = createSelector(
    selectChatState,
    (chat: ChatState): Conversation =>
        chat.conversationMap[chat.currentConversationId] as Conversation
);

export const selectIsCurrentConversationNew = createSelector(
    selectCurrentConversation,
    (conversation: Conversation): boolean =>
        !conversation.messages.length || conversation.conversationId === NEW_CONVERSATION_ID
);

export const selectChatMetadata = createSelector(
    selectChatState,
    (chat: ChatState): ChatMetadata => chat.chatMetadata
);

export const selectIsChatLoading = createSelector(
    selectChatState,
    (chat: ChatState): boolean =>
        chat.isChatting ||
        !!chat.loadingHistoryForConversationId ||
        !!chat.fillingFeedbackForActivityId
);

export const selectConversationSummaryState = createSelector(
    selectChatState,
    ({
        currentConversationId,
        loadingHistoryForConversationId,
        conversationSummaries,
    }: ChatState) => ({
        currentConversationId,
        loadingHistoryForConversationId,
        conversationSummaries,
    })
);
